import { TabProps } from 'src/shared/design-system/Tabs';

export enum Column {
  L = 'left',
  R = 'right',
}

export type TwoColumnProps = {
  children?: React.ReactNode;
  defaultActiveColumn?: Column;
  dockTabsAtTop?: boolean;
  emphasizeColumns?: boolean;
  leftColumn: TabProps & { content: React.ReactNode; hide?: boolean; isTwoColumn?: boolean };
  rightColumn: TabProps & { content: React.ReactNode; hide?: boolean };
  showTabsOnTablet?: boolean;
  showTabsOnMobile?: boolean;
  topContent?: React.ReactNode;
};

export type UseTwoColumnProps = {
  defaultActiveColumn?: TwoColumnProps['defaultActiveColumn'];
};
